<template>
  <div class="custom-main custom-theme">
    <a-row>
      <a-col>
        <a-descriptions class="gpws-descriptions" bordered size="default" :column="{ xxl: 3, xl: 3, lg: 3, md: 3, sm: 2, xs: 1 }">
          <span slot="title">
            <span style="font-size: 16px; font-weight: bold;"><a-icon type="unordered-list" />&nbsp;&nbsp;基本信息</span>
          </span>
          <a-descriptions-item label="机构名称">
            {{((undefined != record.name && null != record.name && '' != record.name)?record.name:'')}}
          </a-descriptions-item>
          <a-descriptions-item label="统一社会信用代码">
            {{((undefined != record.organCode && null != record.organCode && '' != record.organCode)?record.organCode:'')}}
          </a-descriptions-item>
          <a-descriptions-item label="营业执照有效期">
            {{((undefined != record.organValidDate && null != record.organValidDate )?record.organValidDate:'')}}
          </a-descriptions-item>

          <a-descriptions-item label="机构类型">
            {{((undefined != record.categoryName && null != record.categoryName && '' != record.categoryName)?record.categoryName:((undefined != record.typeName && null != record.typeName && '' != record.typeName)?record.typeName:''))}}
          </a-descriptions-item>
          <a-descriptions-item label="是否为互联网医院">{{((record.carp)?'是':'否')}}</a-descriptions-item>
          <a-descriptions-item label="是否为医保定点单位">{{((record.hcUnit)?'是':'否')}}</a-descriptions-item>
          <a-descriptions-item label="法人姓名">
            {{((undefined != record.leaderName && null != record.leaderName ) ? record.leaderName:'')}}
          </a-descriptions-item>
          <a-descriptions-item label="法人身份证号">
            {{((undefined != record.leaderIdcard && null != record.leaderIdcard ) ? record.leaderIdcard:'')}}
          </a-descriptions-item>
          <a-descriptions-item label="法人身份证有效期">
            {{((undefined != record.leaderStartDate && null != record.leaderStartDate ) ? record.leaderStartDate:'')}}到{{((undefined != record.leaderEndDate && null != record.leaderEndDate ) ? record.leaderEndDate:'')}}
          </a-descriptions-item>
          <a-descriptions-item label="法人电话">
            {{((undefined != record.leaderPhone && null != record.leaderPhone)?record.leaderPhone:'')}}
          </a-descriptions-item>
          <a-descriptions-item label="机构地址">
            {{((undefined != record.address && null != record.address && '' != record.address)?record.address.fullAddress:'')}}
          </a-descriptions-item>
        </a-descriptions>
      </a-col>
      <a-col>
        <a-card size="small" :bordered="false" style="margin-top: 24px;">
          <span slot="title" style="margin-left: 36px;">
            <span style="font-size: 16px; font-weight: bold;"><a-icon type="file-image" />&nbsp;&nbsp;资质文件</span>
          </span>
          <a-row>
            <a-col :xxl="5" :xl="5" :lg="5" :md="5" :sm="12" :xs="24" style="justify-content: center;display:grid;">
              <span style="margin-top: 12px; margin-bottom: 12px;text-align: center;">法人身份证(人像面)</span>
              <img v-if="(undefined != record.lif && null != record.lif && '' != record.lif)" :src="record.lif"  @click="previewImg(record.lif)" width="125px" height="125px"/>
              <a-empty v-else :image="emptyImage"></a-empty>
            </a-col>
            <a-col :xxl="5" :xl="5" :lg="5" :md="5" :sm="12" :xs="24" style="justify-content: center;display:grid;">
              <span style="margin-top: 12px; margin-bottom: 12px;text-align: center;">法人身份证(国徽面)</span>
              <img v-if="(undefined != record.lib && null != record.lib && '' != record.lib)" :src="record.lib"  @click="previewImg(record.lib)" width="125px" height="125px"/>
              <a-empty v-else :image="emptyImage"></a-empty>
            </a-col>
            <a-col :xxl="5" :xl="5" :lg="5" :md="5" :sm="12" :xs="24" style="justify-content: center;display:grid;">
              <span style="margin-top: 12px; margin-bottom: 12px;text-align: center;">营业执照</span>
              <img v-if="(undefined != record.lic && null != record.lic && '' != record.lic)" :src="record.lic"  @click="previewImg(record.lic)" width="125px" height="125px"/>
              <a-empty v-else :image="emptyImage"></a-empty>
            </a-col>
            <a-col :xxl="5" :xl="5" :lg="5" :md="5" :sm="12" :xs="24" style="justify-content: center;display:grid;">
              <span style="margin-top: 12px; margin-bottom: 12px;text-align: center;">医疗机构执业许可证</span>
              <img v-if="(undefined != record.pc && null != record.pc && '' != record.pc)" :src="record.pc"  @click="previewImg(record.pc)" width="125px" height="125px"/>
              <a-empty v-else :image="emptyImage"></a-empty>
            </a-col>
            <a-col :xxl="4" :xl="4" :lg="4" :md="4" :sm="12" :xs="24" style="justify-content: center;display:grid;">
              <span style="margin-top: 12px; margin-bottom: 12px;text-align: center;">药品经营许可证</span>
              <img v-if="(undefined != record.gsp && null != record.gsp && '' != record.gsp)" :src="record.gsp"  @click="previewImg(record.gsp)" width="125px" height="125px"/>
              <a-empty v-else :image="emptyImage"></a-empty>
            </a-col>
          </a-row>
        </a-card>
      </a-col>
      <a-col>
        <a-card class="gpws-descriptions" size="small" :bordered="false" :head-style="{paddingLeft: '0px'}" style="margin-top: 24px;">
          <span slot="title">
            <span style="font-size: 16px; font-weight: bold;"><a-icon type="audit" />&nbsp;&nbsp;审批信息</span>
          </span>
          <a-row :gutter="{ xs: 8, sm: 16, md: 24}">
            <a-col :xxl="2" :xl="2" :lg="2" :md="3" :sm ="6" :xs = "8" style="text-align: center;">审批结果：</a-col>
            <a-col :xxl="6" :xl="6" :lg="6" :md="7" :sm ="6" :xs = "16">{{record.statusName}}</a-col>
            <a-col v-if="(record.status == 'NO_PASS' || record.status == 'APPROVED')" :xxl="2" :xl="2" :lg="2" :md="3" :sm ="6" :xs = "8">原因：</a-col>
            <a-col v-if="(record.status == 'NO_PASS' || record.status == 'APPROVED')" :xxl="14" :xl="14" :lg="14" :md="11" :sm ="6" :xs = "16">

              {{ (((record.status == 'NO_PASS' || record.status == 'APPROVED') && (undefined != record.approve && null != record.approve && '' != record.approve))?record.approve:'') }}
            </a-col>
          </a-row>
        </a-card>
      </a-col>
    </a-row>
    <div class="button-container">
      <div>
        <a-button type="primary" style="float:right;margin-right: 48px;" @click="editOrgan">修改</a-button>
      </div>
    </div>
  </div>
</template>

<script>
import { Empty } from 'ant-design-vue';
import Vue from 'vue'
import hevueImgPreview from 'hevue-img-preview';
Vue.use(hevueImgPreview);
export default {
  name: "Organ",
  data() {
    return {
      emptyImage:Empty.PRESENTED_IMAGE_SIMPLE,
      current: {},
      record:{}
    }
  },
  mounted() {
    const self = this;
    this.current = JSON.parse(localStorage.getItem("curruser"));
    this.$axios.get('/api/clinic/'+this.current.organId+'/mine').then(function (res) {
      if (res.msg.flag == 0) {
        if(null != res.biz){
          self.record = res.biz;
          if(undefined != res.biz.approves && null != res.biz.approves && res.biz.approves.length > 0){
            self.record.approve=res.biz.approves[res.biz.approves.length - 1].cause;
          }
          if(undefined != res.biz.certificates && null != res.biz.certificates && res.biz.certificates.length > 0){
            res.biz.certificates.forEach(function (e) {
              if(e.type=='LIF'){
                self.record.lif = e.path.url;
              }
              if(e.type=='LIB'){
                self.record.lib = e.path.url;
              }
              if(e.type=='LIC'){
                self.record.lic = e.path.url;
              }
              if(e.type=='PC'){
                self.record.pc = e.path.url;
              }
              if(e.type=='GSP'){
                self.record.gsp = e.path.url;
              }
            });
          }
        }
      }
    }, function (res) {
    });
  },
  beforeCreate() {
    let data = [{
      text: "首页",
      path: ""
    },{
      text: "医院管理",
      path: ""
    },{
      text: "我的诊室",
      path: ""
    }];
    this.$store.commit('updateBreadcrumb', data);
  },
  methods:{
    editOrgan:function (){
      this.$router.push({ path: '/layout/system/organ/edit'});
    },
    previewImg (imgUrl) {
      this.$hevueImgPreview({
        url: imgUrl,
        keyboard: true,
      });
    }
  }
}
</script>

<style scoped>
.gpws-descriptions {
  margin-left: 48px;
  margin-right: 48px;
  margin-top: 24px;
}
.gpws-descriptions .ant-descriptions-item-label {
  text-align: center!important;
}
@media screen and (min-width: 1200px) {
  .gpws-descriptions .ant-descriptions-item-label {
    width: 198px!important;
  }
}
</style>
